import React from 'react'
import { Lock } from 'lucide-react'

// LapsedBanner (FE4) — the ROSE banner for a BLOCKED account: payment failed and the 5-day grace
// has run out (subscription_status past_due + access_frozen_at present). This is the most severe
// of the three states, so it takes the destructive rose tone, distinct from TrialBanner (teal) and
// GraceBanner (amber). The customer's PMS prices are never held hostage: their last rates remain
// in Eviivo (commercial model § 4). Display only — no money math.
//
// TWO WORDS THIS COPY MUST NOT USE, and both were in it before C3:
//
//   "frozen"    — an internal column name (`access_frozen_at`). Operators read "paused", always
//                 (docs/plans/2026-08-14 vocabulary; the same rule that keeps "internal" off every
//                 surface). This banner sat directly beneath a strip already saying "paused",
//                 describing the same fact in two words.
//   "read-only" — no longer true. Before the paywall (billing lifecycle §6, decision 4) a blocked
//                 operator kept their hotel pages and simply could not save; now those pages
//                 redirect here. Promising a read-only workspace describes a product we stopped
//                 shipping the moment this page became the only place they land.
export default function LapsedBanner() {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-rose-200 bg-rose-50 p-4 shadow-sm">
      <Lock className="mt-0.5 h-5 w-5 shrink-0 text-rose-500" />
      <div className="text-sm">
        <p className="font-semibold text-rose-800">Access is paused: billing needs attention</p>
        <p className="mt-0.5 text-rose-700">
          Your grace period has ended, so rate pushes and your hotel pages are paused until payment is resolved. Add or
          update your card to restore access. Your last published rates remain live in your PMS.
        </p>
      </div>
    </div>
  )
}
